module.exports = __webpack_public_path__ + "static/img/jaiyeola.d6fc93d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/members/jaiyeola.jpg
// module id = TlCc
// module chunks = 1